<!-- Marker column: event pastille + the rail segment that links it to the next entry -->
<div class="relative flex w-6 flex-none justify-center">
  <!-- With the badge gone, the marker is the only carrier of the event: it exposes the label rather
       than staying decorative, so the information survives for assistive tech and on hover. -->
  <span
    [attr.aria-label]="eventLabelKey() | translate"
    [class]="markerClasses()"
    [title]="eventLabelKey() | translate"
    class="relative z-10 flex h-6 w-6 flex-none items-center justify-center rounded-full border">
    <span [class]="iconClass()" aria-hidden="true" class="pi text-[0.65rem]"></span>
  </span>
  @if (!isLast()) {
    <!-- -bottom-5 spans this row's pb-2.5 plus the next row's pt-2.5, so the segments join unbroken -->
    <span aria-hidden="true" class="absolute top-7 -bottom-5 left-1/2 w-px -translate-x-1/2 bg-primary-100"></span>
  }
</div>

<!-- Content column -->
<div class="flex min-w-0 flex-1 flex-col gap-1 pt-0.5 pr-2">

  <!-- Single header row: product name, then author and timestamp pinned right. The avatar already
       carries the full name in its own tooltip, so no name is spelled out here. -->
  <div class="flex min-w-0 items-center gap-2">
    <!-- An extra feature is named under its licence, the only way to tell which one it was added to.
         The chain reads as one line so the truncation eats the tail, never the licence. -->
    <span [title]="productLabel()" class="min-w-0 flex-1 truncate leading-snug">
      @if (parentProductName()) {
        <span class="text-[var(--p-surface-500)]">{{ parentProductName() }}</span>
        <span aria-hidden="true" class="text-[var(--p-surface-400)]">&nbsp;›&nbsp;</span>
      }
      <span class="font-semibold">{{ entry().productName }}</span>
    </span>
    <span class="flex-none text-xs whitespace-nowrap tabular-nums text-[var(--p-surface-600)]">
      {{ entry().createdAt | date: 'dd/MM/yyyy HH:mm' }}
    </span>
    @if (entry().createdBy) {
      <elcia-avatar [avatars]="authors()" [maxItem]="1" class="flex-none"/>
    } @else {
      <span
        [attr.aria-label]="'product-customer.history.unknown-author' | translate"
        [title]="'product-customer.history.unknown-author' | translate"
        class="pi pi-user flex-none text-xs text-[var(--p-surface-400)]"></span>
    }
  </div>

  <!-- One row per changed field. del/ins convey before/after structurally, so the
       strikethrough is never the only cue; values are clamped to keep long
       descriptions (up to 2000 chars) from stretching this narrow column. -->
  @if (changes().length > 0) {
    <div class="mt-0.5 flex flex-col gap-0.5 border-l-2 border-primary-50 pl-3">
      @for (change of changes(); track $index) {
        <div class="flex flex-wrap items-baseline gap-x-1.5 gap-y-0.5 text-xs">
          <span class="text-[var(--p-surface-600)]">
            {{ 'product-customer.history.change-label' | translate: {field: change.label} }}
          </span>
          <del
            class="line-clamp-2 min-w-0 break-words text-[var(--p-surface-600)] line-through decoration-[var(--p-surface-400)]">{{ change.oldValue }}
          </del>
          <span aria-hidden="true" class="flex-none text-[var(--p-surface-600)]">&rarr;</span>
          <ins
            class="line-clamp-2 min-w-0 break-words font-semibold text-[var(--p-surface-800)] no-underline">{{ change.newValue }}
          </ins>
        </div>
      }
    </div>
  }

</div>
